import { UrlConstants } from "@lib/titan2/dist/game/Constants";
import { FactoryManager } from "@lib/titan2/dist/game/factory/FactoryManager";
import { FontManager } from "@lib/titan2/dist/game/manager/FontManager";
import { Locale } from "@lib/titan2/dist/game/manager/LanguageManager";
import { Logger, LogLevel } from "@lib/titan2/dist/util/log/Logger";
import { WebUtil } from "@lib/titan2/dist/util/web/WebUtil";
import { Factory } from "./factory/Factory";
import { App } from "@lib/titan2/dist/game/App";
export class Pawnshop {
    constructor(version, loadedHandler) {
        this.register();
        this.loadFonts(version, loadedHandler);
    }
    static getApp() {
        return App;
    }
    register() {
        this.factoryManager = FactoryManager.getInstance();
        this.fontManager = FontManager.getInstance();
        this.registerFactory();
        Logger.setLogLevel(LogLevel.VERBOSE);
    }
    registerFactory() {
        let factory = new Factory();
        this.factoryManager.setFactory(factory);
    }
    loadFonts(version, loadedHandler) {
        let cssPath = this.getCSSPath(version);
        this.fontManager.loadWebFonts(version, cssPath, loadedHandler);
    }
    getCSSPath(version) {
        let parameter = WebUtil.getUrlParameter(UrlConstants.LOCALE);
        let locale = Locale.getLocale(parameter);
        /*let id: string = locale.getId();
        if (!locale.useNativeFont()) {
            id = "default";
        }*/
        return [version + "/css/font_" + /*id*/ "default" + ".css", version + "/css/font_common.css"];
    }
}
